// Localized Suspense/loading fallback for content scoped inside AppLayout's Outlet
// (and other authenticated layouts) — unlike FullScreenLoader it fills only its
// relative parent, so the sidebar/header stay visible around it.
import React from 'react'
import { SmallLogo } from '../../../assets/images'

// Same mark as FullScreenLoader — one loader look app-wide; this one just doesn't cover
// the sidebar/header.
const ContentLoader = () => {
  return (
    <div role="status" aria-live="polite" className="absolute inset-0 z-10 flex min-h-[200px] items-center justify-center bg-slate-500/25 backdrop-blur-[1px]">
      <img src={SmallLogo} className="loader h-14 w-auto" alt="" />
      <span className="sr-only">Loading content, please wait…</span>
    </div>
  )
}

export default ContentLoader
